define("calendar/components/calendar/social-profiles/available-profiles", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service", "later/utils/constants"], function (_exports, _component, _templateFactory, _component2, _service, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/service",0,"later/utils/constants",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#unless this.currentGroup.hasInstagram}}
    <Calendar::SocialProfiles::AddProfileLink 
      @profileClass="at--multiProfilePost__addProfileInstagram"
      @profileImage="/assets/images/img--add--instagram.png"
      @currentGroup={{this.currentGroup}}
      @selectedSocialProfileType={{this.SOCIAL_PROFILE_CODES.INSTAGRAM}}
    />
  {{/unless}}
  
  {{#unless this.currentGroup.hasPinterest}}
    <Calendar::SocialProfiles::AddProfileLink 
      @profileClass="at--multiProfilePost__addProfilePinterest"
      @profileImage="/assets/images/img--add--pinterest.png"
      @currentGroup={{this.currentGroup}}
      @selectedSocialProfileType={{this.SOCIAL_PROFILE_CODES.PINTEREST}}
    />
  {{/unless}}
  
  {{#unless this.currentGroup.hasFacebook}}
    <Calendar::SocialProfiles::AddProfileLink 
      @profileClass="at--multiProfilePost__addProfileFacebook"
      @profileImage="/assets/images/img--add--facebook.png"
      @currentGroup={{this.currentGroup}}
      @selectedSocialProfileType={{this.SOCIAL_PROFILE_CODES.FACEBOOK}}
    />
  {{/unless}}
  
  {{#unless this.currentGroup.hasTwitter}}
    <Calendar::SocialProfiles::AddProfileLink 
      @profileClass="at--multiProfilePost__addProfileTwitter"
      @profileImage="/assets/images/img--add--twitter.png"
      @currentGroup={{this.currentGroup}}
      @selectedSocialProfileType={{this.SOCIAL_PROFILE_CODES.TWITTER}}
    />
  {{/unless}}
  
  {{#if this.shouldShowTiktokSwitcher}}
    <Calendar::SocialProfiles::AddProfileLink 
      @profileClass="at--multiProfilePost__addProfileTiktok at--addTiktokAccount__addBtn"
      @profileImage="/assets/images/img--add--tiktok.png"
      @currentGroup={{this.currentGroup}}
      @selectedSocialProfileType={{this.SOCIAL_PROFILE_CODES.TIKTOK}}
    />
  {{/if}}
  
  {{#if this.shouldShowLinkedinSwitcher}}
    <Calendar::SocialProfiles::AddProfileLink 
      @profileClass="at--multiProfilePost__addProfileLinkedin"
      @profileImage="/assets/images/img--add--linkedin.png"
      @currentGroup={{this.currentGroup}}
      @selectedSocialProfileType={{this.SOCIAL_PROFILE_CODES.LINKEDIN}}
    />
  {{/if}}
  
  */
  {
    "id": "tjK4Dd4d",
    "block": "[[[41,[51,[30,0,[\"currentGroup\",\"hasInstagram\"]]],[[[1,\"  \"],[8,[39,1],null,[[\"@profileClass\",\"@profileImage\",\"@currentGroup\",\"@selectedSocialProfileType\"],[\"at--multiProfilePost__addProfileInstagram\",\"/assets/images/img--add--instagram.png\",[30,0,[\"currentGroup\"]],[30,0,[\"SOCIAL_PROFILE_CODES\",\"INSTAGRAM\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[51,[30,0,[\"currentGroup\",\"hasPinterest\"]]],[[[1,\"  \"],[8,[39,1],null,[[\"@profileClass\",\"@profileImage\",\"@currentGroup\",\"@selectedSocialProfileType\"],[\"at--multiProfilePost__addProfilePinterest\",\"/assets/images/img--add--pinterest.png\",[30,0,[\"currentGroup\"]],[30,0,[\"SOCIAL_PROFILE_CODES\",\"PINTEREST\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[51,[30,0,[\"currentGroup\",\"hasFacebook\"]]],[[[1,\"  \"],[8,[39,1],null,[[\"@profileClass\",\"@profileImage\",\"@currentGroup\",\"@selectedSocialProfileType\"],[\"at--multiProfilePost__addProfileFacebook\",\"/assets/images/img--add--facebook.png\",[30,0,[\"currentGroup\"]],[30,0,[\"SOCIAL_PROFILE_CODES\",\"FACEBOOK\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[51,[30,0,[\"currentGroup\",\"hasTwitter\"]]],[[[1,\"  \"],[8,[39,1],null,[[\"@profileClass\",\"@profileImage\",\"@currentGroup\",\"@selectedSocialProfileType\"],[\"at--multiProfilePost__addProfileTwitter\",\"/assets/images/img--add--twitter.png\",[30,0,[\"currentGroup\"]],[30,0,[\"SOCIAL_PROFILE_CODES\",\"TWITTER\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"shouldShowTiktokSwitcher\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@profileClass\",\"@profileImage\",\"@currentGroup\",\"@selectedSocialProfileType\"],[\"at--multiProfilePost__addProfileTiktok at--addTiktokAccount__addBtn\",\"/assets/images/img--add--tiktok.png\",[30,0,[\"currentGroup\"]],[30,0,[\"SOCIAL_PROFILE_CODES\",\"TIKTOK\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"shouldShowLinkedinSwitcher\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@profileClass\",\"@profileImage\",\"@currentGroup\",\"@selectedSocialProfileType\"],[\"at--multiProfilePost__addProfileLinkedin\",\"/assets/images/img--add--linkedin.png\",[30,0,[\"currentGroup\"]],[30,0,[\"SOCIAL_PROFILE_CODES\",\"LINKEDIN\"]]]],null],[1,\"\\n\"]],[]],null]],[],false,[\"unless\",\"calendar/social-profiles/add-profile-link\",\"if\"]]",
    "moduleName": "calendar/components/calendar/social-profiles/available-profiles.hbs",
    "isStrictMode": false
  });

  let AvailableProfilesComponent = (_class = class AvailableProfilesComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _defineProperty(this, "SOCIAL_PROFILE_CODES", _constants.SOCIAL_PROFILE_CODES);
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get currentGroup() {
      return this.auth.currentGroup;
    }

    get shouldShowLinkedinSwitcher() {
      return !this.currentGroup.hasLinkedin;
    }

    get shouldShowTiktokSwitcher() {
      return !this.currentGroup.hasTiktok && this.currentAccount.canTiktok;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = AvailableProfilesComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AvailableProfilesComponent);
});